// ABOUTME: Safe redirect/return_to validation for the in-app auth flows (prevents open redirects).
// ABOUTME: Also extracts the Ory error id from an Axios error body.

import config from "@/config"

/** return_to must be an internal path — never an absolute/external URL from the query. */
export const safeReturnTo = (raw: string | null): string =>
  raw && raw.startsWith("/") && !raw.startsWith("//") ? raw : "/"

/**
 * A `redirect_browser_to` from Kratos is server-computed, but we still validate the host
 * before navigating: allow same-origin, the OIDC providers, and the configured Kratos host.
 * Anything else falls back to the app root rather than being followed.
 */
export const safeRedirect = (raw: string): string => {
  try {
    const url = new URL(raw, window.location.origin)
    if (url.origin === window.location.origin) return url.pathname + url.search + url.hash
    const allowed = ["accounts.google.com", "appleid.apple.com"]
    try {
      allowed.push(new URL(config.KRATOS_API_URL, window.location.origin).host)
    } catch {
      /* KRATOS_API_URL may be a relative path — no host to add */
    }
    if (allowed.includes(url.host)) return url.href
  } catch {
    /* unparseable → fall through */
  }
  return "/"
}

/** Extract the Ory error id (e.g. "session_already_available") from an Axios error body. */
export const kratosErrorId = (err: unknown): string | undefined => {
  const data = (err as { response?: { data?: unknown } }).response?.data
  if (data && typeof data === "object" && "error" in data) {
    return (data as { error?: { id?: string } }).error?.id
  }
  return undefined
}
